export class GoogleTagManagerHelper {
  init(id, link) {
    window.dataLayer = window.dataLayer || [];
    var f = document.getElementsByTagName('script')[0],
      j = document.createElement('script');
    j.async = true;
    j.src = link + id;
    f.parentNode.insertBefore(j, f);
  }

  gtag(...params) {
    window.gtag(...params);
  }

  pushToDataLayer(dataLayerItem) {
    window.dataLayer.push(dataLayerItem);
  }
}

export default new GoogleTagManagerHelper();
